import script from "./LgpdSignaturesAndLegitimateInterestConsentConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./LgpdSignaturesAndLegitimateInterestConsentConfig.vue?vue&type=script&setup=true&lang=js"

import "./LgpdSignaturesAndLegitimateInterestConsentConfig.vue?vue&type=style&index=0&id=28da4bbd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28da4bbd"]])

export default __exports__